import LegalLayout from "./LegalLayout";
export default function Cookie() {
  return (
    <LegalLayout title="Cookie Policy">
      <p>
        Il sito utilizza cookie tecnici necessari al funzionamento e, previo
        consenso, cookie analitici e di terze parti (es. Google Analytics, Meta
        Pixel, TikTok Pixel). Puoi modificare in qualsiasi momento le tue
        preferenze tramite il banner presente sul sito.
      </p>
      <h3>Tipologie di cookie</h3>
      <ul>
        <li>Cookie tecnici essenziali</li>
        <li>Cookie analitici anonimi</li>
        <li>Cookie di marketing (previo consenso)</li>
      </ul>
      <p>Il testo definitivo dovrà essere verificato da un professionista.</p>
    </LegalLayout>
  );
}
